import React, {useEffect} from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import me from '../assets/logo1.png';
import { Link } from "react-scroll";
import Aos from 'aos';
import "aos/dist/aos.css";

const Home = () => {
  useEffect (()=>{
      Aos.init({duration: 2000, useClassNames: false});
    }, [])
  return (
    <div
    name="home"
    className="h-screen w-full bg-[#0a192f]"
  >
    <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full pt-20 px-8 md:flex-row z-0" data-aos="fade-up"> 
      <div className="flex flex-col justify-center h-full">
        <h2 className="text-4xl sm:text-7xl font-bold text-white mt-8" >
          I'm a <span className='text-red-600'>Web & Discord
              Developer
            </span>
        </h2>
        <p className="text-gray-500 py-4 max-w-md">
           I have 4+ years of experience in web design and web development.
          Currently, I love to work on web application using technologies like
          React, Tailwind, Next.js and many others. Also, I love being on Discord
          so I work on Bots Development & Servers Security using discord.py and discord.js! 
        </p>
        <div>
          <Link
            to="about"
            smooth
            duration={500}
            className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-red-500 to-red-800 cursor-pointer"
          >
            About Me
            <span className="group-hover:rotate-90 duration-300">
              <HiArrowNarrowRight size={25} className="ml-3" />
            </span>
          </Link>
        </div>
      </div>
      <div>
        <img
          src={me}  
          alt="my profile"
          className="rounded-2xl mx-auto w-2/3 py-4 md:w-full"
        />
      </div>
    </div>
  </div>
  );
};
export default Home;